"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#F5FAF6",
  z100: "#E7F5EA",
  z200: "#C8EDD0",
  z300: "#8ADC82",
  z400: "#67C54F",
  z500: "#50B547",
  z600: "#4B9B42",
  z700: "#38882F",
  z800: "#165C26",
  z900: "#144620",
  z_hover: "#8ADC82",
  rgb: {
    z100: "220,255,228",
    z200: "135,68,72",
    z300: "133,232,156",
    z400: "52,208,88",
    z500: "40,167,69",
    z600: "34,134,58",
    z700: "23,111,44",
    z800: "22,92,38",
    z900: "20,70,32"
  }
};
exports["default"] = _default;